<template>
    <div class="bg-white">
        <slot/>
    </div>
</template>

<script setup>

</script>

<style scoped>

</style>